﻿import { createBrowserRouter, Navigate } from 'react-router-dom';
import { SamplerManagementPage } from '../pages/sampler-management-page.tsx';
import { ProtectedLayout } from './protected-route.tsx';
import { HomePage } from '../pages/home-page.tsx';
import { SamplingBoardPlanningPage } from '../pages/sampling-board-planning-page.tsx';
import { SamplingBoardStatusPage } from '../pages/sampling-board-status-page.tsx';
import { SamplingMetricsPage } from '../pages/sampling-metrics-page.tsx';
import { SamplingTimelinePage } from '../pages/sampling-timeline-page.tsx';

export const router = createBrowserRouter([
  {
    element: <ProtectedLayout />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: 'sampling-board',
        children: [
          {
            path: 'planning',
            element: <SamplingBoardPlanningPage />,
          },
          {
            path: 'status',
            element: <SamplingBoardStatusPage />,
          },
        ],
      },
      {
        path: 'sampling-metrics',
        element: <SamplingMetricsPage />,
      },
      {
        path: 'sampling-timeline',
        element: <SamplingTimelinePage />,
      },
      {
        path: 'sampler-management',
        element: <SamplerManagementPage />,
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
]);
